import React from "react";
import parse from "html-react-parser";

/**
 *
 * props
 * filterdata {Object}
 * objectfilter {Object}
 *
 */
class FilterChoice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  hasValue(value) {
    // if (this.props.filterdata.multiple) {
      if (typeof value === 'object') {
        if (this.props.objectfilter.length === 0) {
          return "choice_item--chosen";
        }
      } else {
        const response = this.props.objectfilter.find((option) => {
          return option === value;
        });
        if (response !== undefined) {
          return "choice_item--chosen";
        } else {
          return undefined;
        }
      }
      // const response = this.props.objectfilter.find((option) => {
      //   if (option === value) {
      //     return true;
      //   }
      //   return false;
      // });
      // if (response) {
      //   return "choice_item--chosen";
      // } else {
      //   return undefined;
      // }
    // } else {
    //   if (this.props.objectfilter === value) {
    //     return "choice_item--chosen";
    //   } else {
    //     return undefined;
    //   }
    // }
  }

  render() {
    const filterdata = this.props.filterdata;
    const choiceOptions = this.props.filterdata.options;
    return (
      <div className={"filter-options"} >
        <p className={`filter-options-title filter-options-title--lessmargin`}>{filterdata.title}</p>
        {filterdata.multiple? <p className={"filter-options-instructions"}>Puedes elegir más de una opción</p> : 
        <p className={"filter-options-instructions"}>Elige una opción</p>}
        <div className={"choice_wrapper"}>
          {choiceOptions.map((option) => {
            //Each option for the filter
            return (
              <div
                key={`filterkeyvalue-${option.value}`}
                className={"choice_item-wrapper"}
              >
                <div
                  onClick={this.props.onClick.bind(
                    this,
                    option.value,
                    filterdata.multiple,
                    filterdata.key
                  )}
                  className={`choice_item ${this.hasValue(option.value) || ""}`}
                >
                  <div className={"choice_item_image-container"}>
                    {parse(option.image)}
                  </div>
                  <div className={"choice_item_text"}>{option.name}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default FilterChoice;
